import { AxiosResponse } from 'axios';

import { RootState } from 'store/store';

export const selectStatusCode = (state: RootState): number | undefined => state.errors.error?.status;
export const selectResponseData = (state: RootState): AxiosResponse | undefined => state.errors.error;
